<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col lg="12">
          <h2>Pedidos</h2>
        </b-col>

        <b-col lg="12" class="mb-3">
          <b-dropdown text="Status Pedido" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 160px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-radio-group
                  @input="updateForm('status', $event)"
                  :options="statusOptions"
                  :checked="filters.status"
                ></b-form-radio-group>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="Status Entrega" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 160px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-radio-group
                  @input="updateForm('deliveryStatus', $event)"
                  :options="deliveryOptions"
                  :checked="filters.deliveryStatus"
                ></b-form-radio-group>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="Cobrança" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 200px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-input type="number" @input="updateForm('charge', $event)" :value="filters.charge" placeholder="12345"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="Pedido" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 200px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-input type="number" @input="updateForm('id', $event)" :value="filters.id" placeholder="12345"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="E-mail" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 250px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-input type="text" @input="updateForm('email', $event)" :value="filters.email" placeholder="pessoa@gmail.com"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="Evento" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 250px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-input type="text" @input="updateForm('eventName', $event)" :value="filters.eventName" placeholder="Festa de São João"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-dropdown text="Ordernar por" class="mr-1 mt-2">
            <b-dropdown-form class="b-dropdown-form" style="width: 220px;" @submit.prevent="filter">
              <b-form-group>
                <b-form-radio-group
                  :options="sortOptions"
                  @input="updateForm('sort', $event)"
                  :checked="filters.sort"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group>
                <b-form-radio-group
                  :options="orderOptions"
                  @input="updateForm('orderby', $event)"
                  :checked="filters.orderby"
                ></b-form-radio-group>
              </b-form-group>
              <b-form-group label="Quantidade:">
                <b-form-input type="number" @input="updateForm('limit', $event)" :value="filters.limit"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
          </b-dropdown>

          <b-btn class="mr-1 mt-2" variant="success" @click="filter">Filtrar</b-btn>
          <b-btn variant="info" class="mr-1 mt-2" @click="showAll">Limpar</b-btn>
        </b-col>

        <b-col lg="12">

          <b-card-group v-if="appliedFilters.length !== 0">
            <b-card
              no-body
              :header="'Filtros:'">
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>

          <b-table striped hover
            :fields="fields"
            :items="orders"
            responsive="md"
          >

            <template v-slot:cell(translated_status)="data">
              <div>
                <span style="color:#27ae60;" v-if="data.item.delivery_status == 'delivered'" title="Entregue">
                  <icon scale="0.9" name="check"></icon>
                </span>
                <span style="color:#e74c3c;" v-if="data.item.delivery_status == 'warning'" title="Atenção">
                  <icon scale="0.9" name="exclamation-triangle"></icon>
                </span>
                <span v-else>-</span>
                {{ data.item.status | orderStatus }}
              </div>
            </template>

            <template v-slot:cell(actions)="data">
              <div>
                <router-link class="link" :to="{name: 'Order', params: {id: data.item.id}}">
                  <icon scale="1" name="search"></icon>
                </router-link>
                <b-button
                  variant="info"
                  size="sm"
                  class="ml-2"
                  :disabled="downloadingPDF[data.item.id]"
                  @click="downloadChargebackPDF(data.item.id)"
                  title="Baixar PDF Defesa Chargeback"
                >
                  <b-spinner small v-if="downloadingPDF[data.item.id]"></b-spinner>
                  <icon v-else scale="1" class="m-0" name="file-pdf"></icon>
                </b-button>
              </div>
            </template>

          </b-table>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FilterStore from '@/filterStore'

const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'Orders',
  data () {
    return {
      orders: [],
      fields: [
        {key: 'id', label: 'Pedido'},
        {key: 'event.name', label: 'Evento'},
        {key: 'email', label: 'E-mail'},
        {key: 'translated_status', label: 'Status', class: 'text-nowrap'},
        {key: 'created_at', label: 'Criado em', formatter: this.$options.filters.date},
        {key: 'actions', label: 'Ações'}
      ],
      filters: {
        deliveryStatus: '',
        status: 'generated',
        charge: '',
        id: '',
        email: '',
        eventName: '',
        sort: 'id',
        orderby: 'desc',
        limit: '15'
      },
      appliedFilters: [],
      statusOptions: [
        { text: 'Novo', value: 'new' },
        { text: 'Pago', value: 'paid' },
        { text: 'Não Pago', value: 'unpaid' },
        { text: 'Gerado', value: 'generated' },
        { text: 'Link expirado', value: 'expired' },
        { text: 'Todos', value: '' },
      ],
      deliveryOptions: [
        { text: 'Entregue', value: 'delivered' },
        { text: 'Atenção', value: 'warning' },
        { text: 'Todos', value: '' },
      ],
      sortOptions: [
        { text: 'Status Pedido', value: 'status' },
        { text: 'Status Entrega', value: 'delivery_status' },
        { text: 'Cobrança', value: 'charge_id' },
        { text: 'E-mail', value: 'email' },
        { text: 'Pedido', value: 'id' },
        { text: 'Evento', value: 'event_name' },
      ],
      orderOptions: [
        { text: 'A-Z', value: 'asc' },
        { text: 'Z-A', value: 'desc' },
      ],
      filterStore: '',
      downloadingPDF: {}
    }
  },
  async created () {
    this.filterStore = new FilterStore('admin', this.$route.path)
    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    await this.filter()
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value)
    },
    getOrders (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/admin/orders'

      if (filters !== '') {
        url = url + '?' + filters
      }

      return this.$http.get(url).then(res => {
        this.orders = res.body.orders
        this.currentStatus = STATUS_SUCCESS
      }, err => {
        console.log(err)
        this.currentStatus = STATUS_FAILED
      })
    },
    fmtOrderStatus (value) {
      switch (value) {
        case 'new':
          return 'Novo'

        case 'paid':
          return 'Pago'

        case 'unpaid':
          return 'Não Pago'

        case 'generated':
          return 'Gerado'

        case 'expired':
          return 'Expirado'

        default:
          return 'Desconhecido'
      }
    },
    fmtOrderBy (value) {
      switch (value) {
        case 'delivery_status':
          return 'Status Entrega'

        case 'charge_id':
          return 'Cobrança'

        case 'email':
          return 'E-mail'

        case 'id':
          return 'Pedido'

        case 'event_name':
          return 'Evento'

        default:
          return 'Desconhecido'
      }
    },
    fmtSortBy (value) {
      if (value === 'asc') {
        return 'Ascendente'
      }
      return 'Descendente'
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.status !== '') {
        filters.push('status=' + this.filters.status)

        this.appliedFilters.push({
          filter: 'Status Pedido',
          values: this.fmtOrderStatus(this.filters.status)
        })
      }

      if (this.filters.deliveryStatus !== '') {
        filters.push('delivery_status=' + this.filters.deliveryStatus)

        this.appliedFilters.push({
          filter: 'Status Entrega',
          values: this.filters.deliveryStatus === 'delivered' ? 'Entregue' : 'Atenção'
        })
      }

      if (this.filters.charge !== '') {
        filters.push('charge_id=' + this.filters.charge)
        this.appliedFilters.push({
          filter: 'Cobrança',
          values: this.filters.charge
        })
      }

      if (this.filters.id !== '') {
        filters.push('id=' + this.filters.id)
        this.appliedFilters.push({
          filter: 'Pedido',
          values: this.filters.id
        })
      }

      if (this.filters.email !== '') {
        filters.push('email=' + this.filters.email)
        this.appliedFilters.push({
          filter: 'E-mail',
          values: this.filters.email
        })
      }

      if (this.filters.eventName !== '') {
        filters.push('event_name=' + this.filters.eventName)
        this.appliedFilters.push({
          filter: 'Evento',
          values: this.filters.eventName
        })
      }

      if (this.filters.sort !== '') {
        filters.push('sort=' + this.filters.sort)
        this.appliedFilters.push({
          filter: 'Ordenando por',
          values: this.fmtOrderBy(this.filters.sort)
        })
      }

      if (this.filters.orderby !== '') {
        filters.push('order=' + this.filters.orderby)
        this.appliedFilters.push({
          filter: 'Tipo ordenação',
          values: this.fmtSortBy(this.filters.orderby)
        })
      }

      if (this.filters.limit !== '') {
        filters.push('limit=' + this.filters.limit)
        this.appliedFilters.push({
          filter: 'Total pedidos',
          values: this.filters.limit
        })
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getOrders(filters)
    },
    async showAll () {
      this.reset()
      await this.filter()
    },
    reset () {
      this.appliedFilters = []
      this.filters.deliveryStatus = ''
      this.filters.status = 'generated'
      this.filters.charge = ''
      this.filters.order = ''
      this.filters.email = ''
      this.filters.eventName = ''
      this.filters.sort = 'id'
      this.filters.orderby = 'desc'
      this.filters.limit = '5'
      this.filterStore.clear()
    },
    async downloadChargebackPDF (orderId) {
      // Set loading state
      this.$set(this.downloadingPDF, orderId, true)

      try {
        // Construct API URL with /b prefix for proxy
        const url = `${process.env.VUE_APP_URL_APP}/b/admin/orders/${orderId}/chargeback-pdf`

        // Make HTTP GET request with blob response type
        const response = await this.$http.get(url, { responseType: 'blob' })

        // Create blob from response
        const blob = new Blob([response.data], { type: 'application/pdf' })

        // Create object URL
        const blobUrl = window.URL.createObjectURL(blob)

        // Create temporary anchor element
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `defesa-chargeback-compra-${orderId}.pdf`

        // Append to body, trigger click, remove from body
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // Cleanup object URL
        window.URL.revokeObjectURL(blobUrl)

        // Show success toast
        this.$bvToast.toast('PDF gerado com sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          toaster: 'b-toaster-top-center',
          solid: true
        })
      } catch (err) {
        console.error(err)

        // Show error toast
        this.$bvToast.toast('Erro ao gerar PDF. Tente novamente.', {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          solid: true
        })
      } finally {
        // Clear loading state
        this.$set(this.downloadingPDF, orderId, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.orders-list {
  .order-id {
    width: 8%;
  }
  .event-name {
    width: 25%;
  }
  .order-email {
    width: 20%;
  }
  .order-status {
    width: 12%;
  }
  .order-delivery-status {
    width: 13%;
  }
  .order-created-at {
    width: 12%;
  }
  .order-actions {
    width: 10%;
  }
  td, th {
    &.order-status,
    &.order-delivery-status,
    &.order-actions {
      text-align: center;
    }
  }
}
</style>
